import React from 'react'

const CandidateIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8672 14.375V9.5L12.4922 4.625L3.11719 9.5L12.4922 14.375L17.3672 12.125V17.375C17.3672 18.875 15.1172 20.375 12.4922 20.375C9.86719 20.375 7.61719 18.875 7.61719 17.375V12.125"
        stroke="#CCCFD6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CandidateIcon
